import { render, staticRenderFns } from "./Link-first-company.vue?vue&type=template&id=421956d9&"
import script from "./Link-first-company.vue?vue&type=script&lang=js&"
export * from "./Link-first-company.vue?vue&type=script&lang=js&"
import style0 from "./Link-first-company.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports